import {
  QButton,
  useCurrentUser,
  useToastProvider,
} from '@qualio/ui-components';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { documentApi } from '../../../../../api/document';
import { DocumentStatus } from '../../../../../api/model/document';
import { ButtonGroupContext } from '../../../Contexts/ButtonGroupContext';
import { DocumentOverviewContext } from '../../Context';
import { shouldRenderSendForReviewButton } from '../../RenderLogic';

export const SendForReviewButton = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const { qualioDocument, refetchDocumentOverviewData, currentEditorMode } =
    useContext(DocumentOverviewContext);
  const { isDisabled, setDisabled } = useContext(ButtonGroupContext);
  const [isSendingForReview, setIsSendingForReview] = useState(false);
  const { showToast } = useToastProvider();

  const commonToastProps = {
    id: 'send-for-review-toast',
    replace: true,
  };

  const handleSendForReview = () => {
    setDisabled(true, setIsSendingForReview);
    documentApi
      .changeStatus(qualioDocument.id, { status: DocumentStatus.For_Review })
      .then(() => {
        setDisabled(false, setIsSendingForReview);
        refetchDocumentOverviewData();
        showToast({
          'data-cy': 'send-for-review-button-notify-success-toast',
          ...commonToastProps,
          description: t('success.successfullySentForReview'),
          status: 'success',
          title: t('notifications.sentForReview'),
        });
      })
      .catch((e) => {
        setDisabled(false, setIsSendingForReview);
        const failureMessage =
          e.response?.data?.message ||
          t('documentActions.failedToSendForReview');
        showToast({
          'data-cy': 'send-for-review-button-notify-error-toast',
          ...commonToastProps,
          status: 'error',
          title: t('notifications.error'),
          description: failureMessage,
        });
      });
  };

  if (
    !shouldRenderSendForReviewButton(
      qualioDocument,
      currentUser,
      currentEditorMode,
    )
  ) {
    return null;
  }

  return (
    <QButton
      isDisabled={isDisabled}
      isLoading={isSendingForReview}
      variant="outline"
      onClick={handleSendForReview}
      data-cy="doc-overview-send-for-review-button"
    >
      {t('buttons.sendForReview')}
    </QButton>
  );
};
